import { AttributeInfoResolver } from '@intercom/interblocks.ts';
export { AttributeInfoResolver };
export const INLINE_CONTROL_BLOCK_TYPES = 'inline_control_block_types';
export const INLINE_CONTROL_ALIGNMENT = 'inline_control_alignments';
/*
  - There are [5 skin tone modifiers](https://emojipedia.org/emoji-modifier-sequence).
  - The default emoji colour we see of yellow is when there isn't a skin tone modifier applied.
    - This is represented with the `NoSkinToneModifier` enum option.
  - The numbers below are the [emoji skin tone modifiers'](https://emojipedia.org/emoji-modifier-sequence) codepoint values.
    - They can be derived by running the [codePointAt](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt) function on each modifier as a character.
*/
export let SkinToneModifiers = /*#__PURE__*/function (SkinToneModifiers) {
  SkinToneModifiers[SkinToneModifiers["NoSkinToneModifier"] = -1] = "NoSkinToneModifier";
  SkinToneModifiers[SkinToneModifiers["LightSkinToneModifier"] = 127995] = "LightSkinToneModifier";
  SkinToneModifiers[SkinToneModifiers["MediumLightSkinToneModifier"] = 127996] = "MediumLightSkinToneModifier";
  SkinToneModifiers[SkinToneModifiers["MediumSkinToneModifier"] = 127997] = "MediumSkinToneModifier";
  SkinToneModifiers[SkinToneModifiers["MediumDarkSkinToneModifier"] = 127998] = "MediumDarkSkinToneModifier";
  SkinToneModifiers[SkinToneModifiers["DarkSkinToneModifier"] = 127999] = "DarkSkinToneModifier";
  return SkinToneModifiers;
}({});